import { useEffect } from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../../lib/i18n/LanguageContext';
import SEO from '../../components/SEO';

// Import the new modular components
import AboutHero from './AboutHero';
import AboutHistory from './AboutHistory';
import AboutLocation from './AboutLocation';
import AboutValues from './AboutValues';

const About = () => {
  const { t } = useLanguage();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [t]);

  // Structured data for about page
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Home',
        item: 'https://rossopomodoro.is/',
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: 'About Us',
        item: 'https://rossopomodoro.is/about',
      },
    ],
  };
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.4 }}
    >
      <SEO
        title={`${t.about.hero.title} | Rossopomodoro`}
        description="Learn about Rossopomodoro Reykjavik, authentic Italian restaurant since 2006. From Naples to downtown Reykjavik, serving best Neapolitan pizza & pasta on Laugavegur."
        canonical="https://rossopomodoro.is/about"
        keywords="Rossopomodoro history, Italian restaurant Reykjavik since 2006, Naples tradition, authentic Neapolitan cuisine, wood-fired oven, Laugavegur restaurant, Italian heritage"
        ldjson={structuredData}
      />

      {/* Compose the modular components */}
      <AboutHero />
      <AboutHistory />
      <AboutLocation />
      <AboutValues />
    </motion.div>
  );
};

export default About;
